import { NotificationEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const getNotificationList = async (
  read: string,
  archive: string,
  filter: string,
  actionFilter: string
): Promise<any> =>
  APIManager.sendGet(
    NotificationEnds.NOTIFICATION_LIST(read, archive, filter, actionFilter),
    true,
    {},
    {},
    axios
  );

const updateNotification = async (data: any, noteId: string): Promise<any> =>
  APIManager.sendPatch(
    NotificationEnds.UPDATE_NOTIFICATION(noteId),
    data,
    true,
    {},
    {},
    axios
  );

const deleteNotification = async (noteId: string): Promise<any> =>
  APIManager.sendDelete(
    NotificationEnds.DELETE_NOTIFICATION(noteId),
    true,
    {},
    {},
    axios
  );

const updateNotificationSetting = async (data: any): Promise<any> =>
  APIManager.sendPatch(
    NotificationEnds.UPDATE_NOTIFICATION_SETTING,
    data,
    true,
    {},
    {},
    axios
  );

const getallNotificationSettings = async (): Promise<any> =>
  APIManager.sendGet(
    NotificationEnds.GET_ALL_NOTIFICATION_SETTINGS,
    true,
    {},
    {},
    axios
  );

export const NotificationService = {
  getNotificationList,
  updateNotification,
  deleteNotification,
  updateNotificationSetting,
  getallNotificationSettings,
};
